var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"d-flex flex-row justify-content-between",class:[_vm.data.staticClass]},[_c('div',{class:_vm.props.textClass},[_vm._t("text")],2),_c('div',{staticClass:"d-flex align-items-center",class:_vm.props.valueClass},[_vm._t("value")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }